import React, { useState } from "react";

function InternShipCards({ internship }) {
  return (
    <div
      className="group relative rounded-3xl bg-white/5 border border-white/10 backdrop-blur-md p-4 sm:p-5 shadow-xl shadow-slate-950/40 hover:-translate-y-1 hover:border-[#5989C8]/70 transition-all duration-200"
      data-aos="fade-up"
    >
      <div className="relative overflow-hidden rounded-2xl mb-4">
        <img
          src={internship.img}
          alt={internship.projectName}
          className="w-full h-44 sm:h-52 lg:h-60 object-cover rounded-2xl transition-transform duration-300 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-950/70 via-transparent to-transparent opacity-70" />
        <span className="absolute left-3 top-3 rounded-full bg-emerald-500/90 px-3 py-1 text-[11px] font-medium text-slate-950">
          Internship
        </span>
      </div>

      <div className="space-y-3">
        <h3 className="text-base sm:text-lg font-semibold text-white">
          {internship.projectName}
        </h3>
        <p className="text-sm sm:text-[15px] text-slate-300/90">
          {internship.description}
        </p>

        <div className="flex items-center justify-between mt-1">
          <div className="flex items-center text-yellow-400 text-sm">
            {Array.from({ length: Math.round(internship.rating) }).map(
              (_, i) => (
                <span key={i}>⭐</span>
              )
            )}
            <span className="text-xs sm:text-sm text-slate-300 ml-1">
              {internship.rating} ({internship.numberOfReviews} reviews)
            </span>
          </div>
          <button className="rounded-full border border-[#5989C8] px-3 sm:px-4 py-2 text-xs sm:text-sm font-medium text-slate-100 hover:bg-[#064585] hover:border-[#064585] hover:-translate-y-0.5 shadow-lg shadow-slate-900/60 transition-all duration-200">
            Enquire Now
          </button>
        </div>
      </div>
    </div>
  );
}

export default InternShipCards;
